import { Icon } from "@iconify/react";
import React from "react";
import { Link } from "react-router-dom";

import TemplateImg from "../../../assets/images/no-template.svg";
const LookUpsEmpty = () => {
  return (
    <div className="no-template">
      <img src={TemplateImg} alt="" />
      <h4>No values added yet</h4>
      <p>
        There are no values available for this lookup. <br /> Click the button
        above to start adding values
      </p>
      {/* <Link to="#" className='btn cta-primary-light mt-4'>  Add new template 
        <i className="ms-2">
          <Icon icon="ant-design:plus-outlined" />
        </i>
        </Link> */}
    </div>
  );
};

export default LookUpsEmpty;
